export default [
  {
    title: 'مدیریت بنرها',
    icon: 'bx bx-chalkboard',
    children: [
      {
        title: 'بنرها',
        route: { name: 'banner' },
        resource: 'BannerManager',
        action: 'show',
      },
      {
        title: 'جایگاه ها',
        route: { name: 'bannerposition' },
        resource: 'BannerManager',
        action: 'show',
      },
    ],
  },
]
